import { FC } from "react";
import { IconPropsType } from ".";

export const Telegram2: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3491_8592)">
        <path
          d="M20 10C20 15.525 15.525 20 10 20C4.475 20 0 15.525 0 10C0 4.475 4.475 0 10 0C15.525 0 20 4.475 20 10Z"
          fill="url(#paint0_linear_3491_8592)"
        />
        <path
          d="M8.16667 14.5834C7.84167 14.5834 7.9 14.4584 7.78334 14.15L6.83334 11.0167L12.7333 7.33337L13.425 7.51671L12.85 9.08337L8.16667 14.5834Z"
          fill="#C8DAEA"
        />
        <path
          d="M8.16666 14.5833C8.41666 14.5833 8.525 14.4667 8.66666 14.3333C8.88333 14.125 11.6667 11.4167 11.6667 11.4167L9.95833 11L8.375 12L8.16666 14.5V14.5833Z"
          fill="#A9C9DD"
        />
        <path
          d="M8.33333 12.0333L12.3667 15.0083C12.825 15.2583 13.1583 15.1333 13.275 14.5833L14.9167 6.84996C15.0833 6.17496 14.6583 5.87496 14.2167 6.07496L4.58333 9.79162C3.92499 10.0583 3.93333 10.425 4.46666 10.5833L6.94166 11.3583L12.6667 7.74996C12.9333 7.58329 13.1833 7.67496 12.9833 7.85829L8.33333 12.0333Z"
          fill="url(#paint1_linear_3491_8592)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_3491_8592"
          x1="12.9308"
          y1="3.16083"
          x2="7.93083"
          y2="14.8273"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#37AEE2" />
          <stop offset="1" stopColor="#1E96C8" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3491_8592"
          x1="10.7492"
          y1="10.3129"
          x2="12.8326"
          y2="13.6462"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EFF7FC" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <clipPath id="clip0_3491_8592">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
